module.exports = __webpack_public_path__ + "img/tagline.62bccb41.png";